/* eslint-disable @typescript-eslint/camelcase */
import { Pagination } from "@/domain/entities/Pagination";
import {
  CargoEntities,
  CargoData,
  CargoDetailStt,
  CargoEditResponse,
  CargoCommodityList,
  CargoCommodityData,
  CargoProductEntities,
  CargoProductData,
  SearchCargoOptions,
  SearchCargoOption,
  AirportEntities,
  AirportData,
  AirportRouteTypeData,
  CargoAddResponse,
  DimensionData,
  DimensionCustomData,
  ListLastReadCargo,
  AirportDetail,
  CargoFlightDetail,
  SearchFlight,
  CargoDetailSttPiece,
  FlightAvailable,
  CargoDetailBagData,
  CalculateVolume,
  CargoDisputeSummaryData,
  CargoMinimumWeightSummaryData,
  CargoSummaryInProcessData,
  CargoSuccessSummaryData,
  CargoFailedUnread,
  CheckEligibleReadyToCargo,
  BagOrStt
} from "@/domain/entities/Cargo";
import { AxiosResponse } from "axios";
import {
  ResponseBagSttDetail,
  ResponsePayload
} from "@/domain/entities/ResponsePayload";
import {
  AwbDetail,
  AwbDetailData,
  AwbTracking,
  StockInformation
} from "@/domain/entities/NGen";
import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";

export class CargoMapper {
  public convertCargoDataFromApi(res: AxiosResponse<any>): CargoEntities {
    const { data } = res;
    return new CargoEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_data),
      data.data?.length ? data.data.map(
        (item: any) =>
          new CargoData({
            totalFlight: item.total_flight,
            id: item.cargo_id,
            cargoNumber: item.cargo_no,
            cargoHubName: item.cargo_hub_name,
            cargoType: item.cargo_type,
            vehiclePoliceNumber: item.cargo_vehicle_no,
            originCityCode: item.cargo_origin_city_code,
            originCityName: item.origin_city_name,
            destinationCityCode: item.cargo_destination_city_code,
            destinationCityName: item.destination_city_name,
            airportOriginCityCode: item.cargo_origin_airport_code,
            airportOriginCityName: item.airport_origin_name,
            airportDestinationCityCode: item.cargo_destination_airport_code,
            airportDestinationCityName: item.airport_destination_name,
            originDistrictCode: item.cargo_origin_district_code,
            destinationDistrictCode: item.cargo_destination_district_code,
            totalStt: item.cargo_total_stt,
            totalPieces: item.cargo_total_stt_piece,
            totalGrossWeight: item.cargo_total_gross_weight,
            totalVolumeWeight: item.cargo_total_volume_weight,
            noBag: item.cargo_number,
            createdName: item.created_name,
            updatedByName: item.updated_by_name,
            totalEstCargoGrossWeight: 0,
            totalEstCargoVolumeWeight: 0,
            totalActualCargoGrossWeight: item.cargo_total_custom_gross_weight,
            totalActualCargoVolumeWeight:
              item.cargo_total_custom_volume_weight,
            cargoActualPiece: item.cargo_actual_piece,
            partnerName: "",
            partnerType: "",
            cargoCommodity: "",
            cargoCommodityCode: "",
            cargoProduct: "",
            cargoProductCode: "",
            estimationDepartureData: "",
            estimationDepartureDate: item.cargo_estimation_departure_date,
            departureDate: item.cargo_departure_date,
            departureTime: item.cargo_departure_ngen,
            estimationArrivalDate: item.cargo_estimation_arrival_date,
            arrivalDate: item.cargo_arrival_date,
            arrivalTime: item.cargo_arrival_ngen,
            createdAt: item.cargo_created_at,
                createdBy: item.cargo_created_name,
            updatedAt: item.cargo_updated_at,
            updatedBy: item.cargo_updated_name,
            detailStt: [],
            totalPiecesBagStt: 0,
            actualDimension: new DimensionData(),
            transit: item.total_transit,
            cargoDimensionCustom: [],
            isPlaneManual : item.cargo_is_cargo_plane_manual,
            totalPiecesDimension: 0,
            totalGrossDimension : 0,
            totalChargeableWeight: item.cargo_total_chargeable_weight,
            cargoTotalCustomChargeableWeight: item.cargo_total_custom_chargeable_weight,
            cargoTotalChargeableWeight: item.cargo_total_chargeable_weight,
            cargoTotalCustomGrossWeight: item.cargo_total_custom_gross_weight,
            cargoTotalCustomVolumeWeight: item.cargo_total_custom_volume_weight,
            cargoTotalEstimateChargeableWeight: item.cargo_total_estimate_chargeable_weight,
            cargoTotalEstimateGrossWeight: item.cargo_total_estimate_gross_weight,
            cargoTotalEstimateVolumeWeight: item.cargo_total_estimate_volume_weight,
            cargoTotalGrossWeight: item.cargo_total_gross_weight,
            cargoTotalVolumeWeight: item.cargo_total_volume_weight,
            isDisputeFromBagging: item.is_dispute_from_bagging,
            isDisputeFromCargo: item.is_dispute_from_cargo,
            cargoCommodityGroupIsElectronicDg: item.cargo_commodity_group_is_electronic_dg,
            cargoCommodityGroupIsDg: item.cargo_commodity_group_is_dg,
            cargoCommodityGroupIsQuarantine: item.cargo_commodity_group_is_quarantine,
            isDisputeCargo: item.is_dispute_cargo
          })
      ) : []
    )
  }

  public convertCargoDisputeSummaryDataFromApi(res: AxiosResponse<any>): CargoDisputeSummaryData {
    const { data } = res;
    const { data: dataRes } = data || {}
    return new CargoDisputeSummaryData({
      totalCargoDispute: dataRes?.total_cargo_dispute,
      totalCargoData: dataRes?.total_cargo_data,
      totalPercentage: dataRes?.total_percentage,
      totalPlaneDispute: dataRes?.total_plane_dispute,
      totalPlaneData: dataRes?.total_plane_data,
      totalPlanePercentage: dataRes?.total_plane_percentage,
      totalTruckDispute: dataRes?.total_truck_dispute,
      totalTruckData: dataRes?.total_truck_data,
      totalTruckPercentage: dataRes?.total_truck_percentage,
      totalTrainDispute: dataRes?.total_train_dispute,
      totalTrainData: dataRes?.total_train_data,
      totalTrainPercentage: dataRes?.total_train_percentage,
      totalShipDispute: dataRes?.total_ship_dispute,
      totalShipData: dataRes?.total_ship_data,
      totalShipPercentage: dataRes?.total_ship_percentage,
      startDate: dataRes?.start_date,
      endDate: dataRes?.end_date,
    })
  }

  public convertCargoSuccessSummaryDataFromApi(res: AxiosResponse<any>): CargoSuccessSummaryData {
    const { data } = res;
    const { data: dataRes } = data || {}
    return new CargoSuccessSummaryData({
      plane: dataRes?.plane,
      truck: dataRes?.truck,
      ship: dataRes?.ship
    })
  }

  public convertRetryCargoDataFromApi(res: AxiosResponse<any>): CargoEntities {
    const { data } = res;

    return new CargoEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_data),
      data.data?.length
        ? data.data.map((item: any) => {
            return new CargoData({
              totalFlight: item.rc_total_flight,
              id: item.rc_id,
              cargoNumber: item.rc_no,
              cargoHubName: item.rc_hub_name,
              estimationDepartureDate: item.rc_departure_date,
              estimationArrivalDate: item.rc_arrival_date,
              bookingRequestId: item.rc_booking_request_id,
              isFromRtc: item.is_from_rtc,
              cargoType: item.rc_type,
              vehiclePoliceNumber: item.rc_vehicle_no || "-",
              originCityCode: item.rc_origin_city_code,
              originCityName: JSON.parse(item.rc_remarks).origin_city_name,
              destinationCityCode: item.rc_destination_city_code,
              destinationCityName: JSON.parse(item.rc_remarks)
                .destination_city_name,
              airportOriginCityCode: item.rc_origin_airport_code,
              airportOriginCityName: JSON.parse(item.rc_remarks)
                .airport_origin_name,
              airportDestinationCityCode: item.rc_destination_airport_code,
              airportDestinationCityName: JSON.parse(item.rc_remarks)
                .airport_destination_name,
              originDistrictCode: item.rc_origin_district_code ?? "",
              destinationDistrictCode: item.rc_destination_district_code ?? "",
              totalStt: item.rc_total_stt,
              totalPieces: item.rc_total_stt_piece,
              totalGrossWeight: item.rc_total_gross_weight,
              totalVolumeWeight: item.rc_total_volume_weight,
              totalEstCargoGrossWeight: 0,
              totalEstCargoVolumeWeight: 0,
              totalActualCargoGrossWeight: item.rc_total_custom_gross_weight,
              totalActualCargoVolumeWeight: item.rc_total_custom_volume_weight,
              cargoActualPiece: item.rc_cargo_actual_piece || item.rc_actual_piece,
              partnerName: "",
              partnerType: "",
              cargoCommodity: "",
              cargoCommodityCode: "",
              cargoProduct: "",
              cargoProductCode: "",
              estimationDepartureData: "",
              departureDate: item.rc_departure_date,
              arrivalDate: item.rc_arrival_date,
              createdAt: item.rc_created_at,
              createdBy: item.rc_created_name,
              updatedAt: item.rc_updated_at,
              updatedBy: item.rc_updated_name,
              detailStt: [],
              totalPiecesBagStt: 0,
              actualDimension: new DimensionData(),
              reasonFailed: item.rc_reason_failed,
              cargoDimensionCustom: [],
              isPlaneManual: item.rc_is_cargo_plane_manual,
              totalPiecesDimension: 0,
              totalGrossDimension : 0,
              totalChargeableWeight: item.rc_total_chargeable_weight,
              cargoTotalCustomChargeableWeight: item.rc_total_custom_chargeable_weight,
              isDisputeFromBagging: item.is_dispute_from_bagging,
              isDisputeFromCargo: item.is_dispute_from_cargo,
              cargoStatus: item.rc_status
            });
          })
        : []
    );
  }

  
  public convertCargoDetailFromApi(result: AxiosResponse<any>): CargoData {
    const { data } = result.data;
    return this.createCargoDataFromApiData(data);
  }

  private mapCargoDimensionCustom(data: any): DimensionCustomData[] {
    return data?.map((item: any) => 
      new DimensionCustomData({
            pieces: item.pieces,
            length: item.length,
            width: item.width,
            height: item.height,
            grossWeight: item.gross_weight,
            volumeWeight: item.volume_weight,
            sttOrBag: item.stt_or_bag,
      })
    ) || [];
  }

  private createCargoDetailStts(detailStt: any): CargoDetailStt[] {
    return detailStt
      ? detailStt.map(
          (stt: any) =>
            new CargoDetailStt({
              baggingNumber: stt.bag_no,
              baggingVendorNumber: stt.bag_vendor_no,
              sttNumber: stt.stt_no,
              totalPieces: stt.stt_total_piece,
              grossWeigth: stt.stt_gross_weight,
              volumeWeight: stt.stt_volume_weight,
              productType: stt.stt_product_type,
              commodity: stt.stt_commodity_name,
              origin: stt.stt_origin_city_id,
              destination: stt.stt_destination_city_id,
              sttNoRefExternal: stt.stt_no_ref_external,
              sttTotalPiece: stt.stt_total_piece,
              sttGrossWeight: stt.stt_gross_weight,
              sttVolumeWeight: stt.stt_volume_weight,
              sttProductType: stt.stt_product_type,
              sttCommodityName: stt.stt_commodity_name,
              sttOriginCityId: stt.stt_origin_city_id,
              sttDestinationCityId: stt.stt_destination_city_id,
              isScanByBag: stt.is_scan_by_bag,
              bagData: new CargoDetailBagData({
                bagCustomGrossWeight: stt.bag_custom_gross_weight,
                bagCustomVolumeWeight: stt.bag_custom_volume_weight,
                bagCustomChargeableWeight: stt.bag_custom_chargeable_weight,
              }),
              chargeableWeight: stt.stt_chargeable_weight,
              bagCustomChargeableWeight: stt.bag_custom_chargeable_weight,
              isDisputeBagging: stt.is_dispute_bagging,
              sttClientId: stt.stt_client_id
            })
        )
      : [];
  }

  private createCargoDataFromApiData(data: any): CargoData {
    return new CargoData({
      id: data.cargo_id,
      cargoNumber: data.cargo_number,
      cargoType: data.cargo_type,
      vehiclePoliceNumber: data.vehicle_number,
      originCityCode: data.origin_city_code,
      originCityName: data.origin_city,
      destinationCityCode: data.destination_city_code,
      destinationCityName: data.destination_city,
      airportOriginCityCode: data.origin_airport_code,
      airportOriginCityName: data.origin_airport_name,
      airportDestinationCityCode: data.destination_airport_code,
      airportDestinationCityName: data.destination_airport_name,
      originDistrictCode: "",
      destinationDistrictCode: "",
      totalStt: data.total_stt,
      totalPieces: data.total_piece,
      totalGrossWeight: data.total_gross_weight,
      totalVolumeWeight: data.total_volume_weight,
      noBag: data.cargo_number,
      createdName: data.created_name,
      updatedByName: data.updated_by_name,
      totalEstCargoGrossWeight: data.total_est_cargo_gross_weight,
      totalEstCargoVolumeWeight: data.total_est_cargo_volume_weight,
      totalActualCargoGrossWeight: data.total_actual_cargo_gross_weight,
      totalActualCargoVolumeWeight: data.total_actual_cargo_volume_weight,
      cargoActualPiece: data.cargo_actual_piece,
      partnerName: data.partner_name,
      partnerType: data.partner_type,
      cargoCommodity: data.cargo_commodity,
      cargoCommodityCode: data.cargo_commodity_code,
      cargoProduct: data.cargo_product,
      cargoProductCode: data.cargo_product_code,
      shcCode: data.shc_code,
      shcDescription: data.shc_description,
      estimationDepartureData: data.estimation_departure_data,
      departureDate: data.departure_date,
      arrivalDate: data.arrival_date || data.aririval_date,
      createdAt: data.created_at,
      createdBy: data.created_name,
      updatedAt: data.updated_at,
      updatedBy: data.update_by,
      detailStt: this.createCargoDetailStts(data.detail_stt),
      flightsDetail: this.createFlightsDetail(data.cargo_flight_details),
      totalPiecesBagStt: data.detail_stt
        ? data.detail_stt.reduce((a: any, b: any) => a + b.TotalPiece, 0)
        : 0,
      totalPiecesDimension: this.calculateTotalPiecesDimension(this.mapCargoDimensionCustom(data.cargo_dimension_custom)),
      totalGrossDimension: this.calculateTotalGrossDimension(this.mapCargoDimensionCustom(data.cargo_dimension_custom)),
      actualDimension: this.createDimensionData(data, 'actual'),
      estDimension: this.createDimensionData(data, 'est'),
      nog: data.cargo_nog,
      partnerId: data.partner_id || 0,
      flightNumbers: data.flight_numbers,
      cargoDimensionCustom: this.mapCargoDimensionCustom(data.cargo_dimension_custom),
      nGenCreatedAt: data.ngen_created_at,
      isPlaneManual: data.cargo_is_cargo_plane_manual,
      photoProof: data.photo_proof,
      isAllowUseProof: data.is_allow_use_proof,
      isUseNewCalculation: data.is_use_new_calculation,
      totalChargeableWeight: data.cargo_total_chargeable_weight,
      rcTotalChargeableWeight: data.rc_total_chargeable_weight,
      rcTotalCustomChargeableWeight: data.rc_total_custom_chargeable_weight,
      rcTotalEstimateChargeableWeight: data.rc_total_estimate_chargeable_weight,
      cargoTotalChargeableWeight: data.cargo_total_chargeable_weight,
      cargoTotalEstimateChargeableWeight: data.cargo_total_estimate_chargeable_weight,
      cargoTotalCustomChargeableWeight: data.cargo_total_custom_chargeable_weight,
      calculateType: data.calculate_type,
      isMinimumVolumePerPiece: data.is_minimum_volume_per_piece,
      minVolumePerPiece: data.min_volume_per_piece,
      isValidAwbManual: data.is_valid_awb_manual,
      isCargoDimensionOn: data.is_cargo_dimension_on,
      totalDisputeBagging: data.total_bag_with_weight_dispute || 0,
      totalBagging: data.total_bag || 0,
      isDisputeCargo: data.is_dispute_cargo,
      cargoCommodityGroupIsElectronicDg: data.cargo_commodity_group_is_electronic_dg,
      cargoCommodityGroupIsDg: data.cargo_commodity_group_is_dg,
      cargoCommodityGroupIsQuarantine: data.cargo_commodity_group_is_quarantine,
      currentChargeableWeight: data.current_chargeable_weight
    });
  }

  private createFlightsDetail(flightDetails: any[]): CargoFlightDetail[] {
    return flightDetails?.map((item: any) => {
        return new CargoFlightDetail({
            cfNumber: item.cf_number,
            cfEstDepartureTime: item.cf_est_departure_time,
            cfAirportOrigin: item.cf_airport_origin,
            cfAirportDestination: item.cf_airport_destination
        });
    }) || [];
  }

  private createDimensionData(data: any, type: 'actual' | 'est'): DimensionData {
    return new DimensionData({
        length: data[`cargo_${type}_length_dimension`],
        width: data[`cargo_${type}_width_dimension`],
        height: data[`cargo_${type}_height_dimension`]
    });
  }

public convertRetryCargoDetailFromApi(result: AxiosResponse<any>): CargoData {
  const { data } = result.data;
  return this.createRetryCargoDataFromApiData(data);
}

private createRetryCargoDataFromApiData(data: any): CargoData {
  return new CargoData({
    id: data.rc_id,
    totalFlight: data.rc_total_flight,
    cargoNumber: data.rc_no,
    cargoHubName: data.rc_hub_name,
    estimationDepartureDate: data.rc_departure_date,
    estimationArrivalDate: data.rc_arrival_date,
    bookingRequestId: data.rc_booking_request_id,
    cargoType: data.rc_type,
    vehiclePoliceNumber: data.rc_vehicle_no,
    driverName: data.driver_name,
    originCityCode: data.rc_origin_city_code,
    originCityName: data.rc_origin_city_name,
    destinationCityCode: data.rc_destination_city_code,
    destinationCityName: data.rc_destination_city_name,
    airportOriginCityCode: data.rc_origin_airport_code,
    airportOriginCityName: data.rc_origin_airport_name,
    airportDestinationCityCode: data.rc_destination_airport_code,
    airportDestinationCityName: data.rc_destination_city_name,
    originDistrictCode: "",
    destinationDistrictCode: "",
    totalStt: data.rc_total_stt,
    totalPieces: data.rc_total_stt_piece,
    totalGrossWeight: data.rc_total_gross_weight,
    totalVolumeWeight: data.rc_total_volume_weight,
    totalEstCargoGrossWeight: data.rc_total_estimate_gross_weight,
    totalEstCargoVolumeWeight: data.rc_total_estimate_volume_weight,
    totalActualCargoGrossWeight: data.rc_total_custom_gross_weight,
    totalActualCargoVolumeWeight: data.rc_total_custom_volume_weight,
    cargoActualPiece: data.rc_actual_piece,
    partnerName: data.rc_partner_name,
    partnerType: data.rc_partner_type,
    cargoCommodity: data.rc_commodity_group_name,
    cargoCommodityCode: data.rc_commodity_group_code,
    cargoProduct: data.rc_cargo_product_type_code,
    cargoProductCode: data.rc_cargo_product_code,
    shcCode: data.rc_shc_code,
    shcDescription: data.rc_shc_description,
    estimationDepartureData: data.rc_estimation_departure_data,
    departureDate: data.rc_departure_date,
    arrivalDate: data.rc_arrival_date || data.rc_aririval_date,
    createdAt: data.rc_created_at,
    createdBy: data.rc_created_name,
    updatedAt: data.rc_updated_at,
    updatedBy: data.rc_update_by || data.rc_updated_name,
    detailStt: this.createRetryDetailStt(data.rc_detail, data),
    totalPiecesBagStt: this.calculateTotalPiecesBagStt(data.rc_detail),
    totalPiecesDimension: this.calculateTotalPiecesDimension(
      this.mapCargoDimensionCustom(data.rc_cargo_dimension_custom)
    ),
    totalGrossDimension: this.calculateTotalGrossDimension(
      this.mapCargoDimensionCustom(data.rc_cargo_dimension_custom)
    ),
    actualDimension: new DimensionData({
      length: data.rc_actual_length_dimension,
      width: data.rc_actual_width_dimension,
      height: data.rc_actual_height_dimension
    }),
    estDimension: new DimensionData({
      length: data.rc_est_length_dimension,
      width: data.rc_est_width_dimension,
      height: data.rc_est_height_dimension
    }),
    nog: data.rc_nog,
    partnerId: data.rc_partner_id || 0,
    cargoStatus: data.rc_status,
    cargoDimensionCustom: this.mapCargoDimensionCustom(data.rc_cargo_dimension_custom),
    isFromRtc: data.is_from_rtc,
    isPlaneManual: data.rc_is_cargo_plane_manual,
    isUseSabre: data.rc_is_use_sabre, 
    isOverCutoffTime: data.is_over_cutoff_time, 
    reasonFailed: data.rc_reason_failed, 
    flightPlaneForECargo: data.flight_plan_for_ecargo,
    photoProof: data.photo_proof,
    isAllowUseProof: data.is_allow_use_proof,
    rcTotalChargeableWeight : data.rc_total_chargeable_weight,
    rcTotalCustomChargeableWeight: data.rc_total_custom_chargeable_weight,
    rcTotalEstimateChargeableWeight: data.rc_total_estimate_chargeable_weight,
    cargoTotalChargeableWeight: data.rc_total_chargeable_weight,
    cargoTotalCustomChargeableWeight: data.rc_total_custom_chargeable_weight,
    cargoTotalEstimateChargeableWeight: data.rc_total_estimate_chargeable_weight,
    cargoTotalCustomGrossWeight: data.rc_total_custom_gross_weight,
    cargoTotalCustomVolumeWeight: data.rc_total_custom_volume_weight,
    calculateType: data.calculate_type,
    isCargoDimensionOn: data.is_cargo_dimension_on,
    isValidAwbManual: data.is_valid_awb_manual,
    isNewForm: data.is_new_form,
    totalDisputeBagging: data.total_bag_with_weight_dispute,
    isDisputeCargo: data.is_dispute_cargo,
    isDisputeFromCargo: data.is_dispute_from_cargo,
    isDisputeFromBagging: data.is_dispute_from_bagging,
    onlyTotalBag: data.only_total_bag,
    onlyTotalStt: data.only_total_stt,
    totalBagWithWeightDispute: data.total_bag_with_weight_dispute,
    currentChargeableWeight: data.current_chargeable_weight
  });
}

private createRetryDetailStt(detail: any[], data?: any): CargoDetailStt[] {
  return detail.length > 0
    ? detail.map(
        (stt: any) =>
          new CargoDetailStt({
            baggingNumber: stt.rcd_bag_no,
            baggingVendorNumber: stt.bag_vendor_no,
            sttNumber: stt.rcd_stt_no,
            totalPieces: stt.rcd_stt_total_piece,
            grossWeigth: stt.rcd_stt_gross_wight,
            volumeWeight: stt.rcd_stt_volume_weight,
            productType: stt.rcd_stt_product_type,
            commodity: stt.stt_commodity_name,
            origin: stt.rcd_stt_origin_city_id,
            destination: stt.rcd_stt_destination_city_id,
              commodityGroup: stt.stt_commodity_group_name,
            commodityGroupName: stt.stt_commodity_group_name,
            commodityGroupCode: stt.stt_commodity_group_code,
            commodityGroupIsDg: stt.stt_commodity_group_is_dg,
            bagCustomGrossWeight: stt.rcd_bag_custom_gross_weight,
            bagCustomVolumeWeight: stt.rcd_bag_custom_volume_weight,
            sttNoRefExternal: stt.rcd_stt_no_ref_external,
            shcCode: stt.stt_commodity_shc_code,
            shcName: stt.stt_commodity_shc_description,
            chargeableWeight: stt.stt_chargeable_weight,
            destinationCityCode: stt.rcd_stt_destination_city_id,
            bagCustomChargeableWeight: stt.rcd_bag_custom_chargeable_weight,
            sttGrossWeight: stt.rcd_stt_gross_wight,
            sttVolumeWeight: stt.rcd_stt_volume_weight,
            sttTotalPiece: stt.rcd_stt_total_piece,
            sttProductType: stt.rcd_stt_product_type,
            sttCommodityName: stt.stt_commodity_name,
            isQuarantine: stt.is_quarantine,
            isDangerousGoods: stt.is_dangerous_goods,
            bagPhotoProof: stt.bag_photo_proof,
            isDisputeBagging: stt.is_dispute_bagging,
              sttClientId: stt.stt_client_id
            })
        )
      : [];
}

private calculateTotalPiecesBagStt(detail: any[]): number {
  return detail.reduce((a: any, b: any) => a + b.TotalPiece, 0);
}

private calculateTotalPiecesDimension(detail: DimensionCustomData[]): number {
  return detail.reduce((a: number, b: DimensionCustomData) => a + b.pieces, 0);
}

private calculateTotalGrossDimension(detail: DimensionCustomData[]): number {
  return detail.reduce((a: number, b: DimensionCustomData) => a + b.grossWeight, 0);
}

  public convertCargoEditFromApi(result: AxiosResponse): CargoEditResponse {
    const {
      data: { data }
    } = result;
    return new CargoEditResponse(
      data.cargo_id,
      data.cargo_no,
      data.total_stt_success,
      data.total_stt_failed,
      data.list_stt_failed,
      data.total_stt_add_success,
      data.total_stt_removee_success
    );
  }

  public convertCargoProductDataFromApi(
    res: AxiosResponse<any>
  ): CargoProductEntities {
    const { data } = res;

    const cargos: CargoProductData[] = [];
    if (data.data.length === 0) {
      return new CargoProductEntities([]);
    } else {
      data.data.map((item: any) => {
        cargos.push(
          new CargoProductData(
            item.cargo_product_type_id,
            item.cargo_product_type_code,
            item.cargo_product_type_status
          )
        );
      });
    }
    return new CargoProductEntities(cargos);
  }

  public convertCargoCommodityFromApi(
    result: AxiosResponse
  ): CargoCommodityList {
    const { data } = result;
    const cargoCommodity: CargoCommodityData[] = [];
    for (const commodity of data.data) {
      cargoCommodity.push(
        new CargoCommodityData(
          commodity.commodity_group_id,
          commodity.commodity_group_code,
          commodity.commodity_group_name,
          commodity.created_at,
          commodity.updated_at
        )
      );
    }
    return new CargoCommodityList(
      new Pagination(data.meta.page, data.meta.limit),
      cargoCommodity
    );
  }

  public convertAppendBagOrSttDataFromApi(
    result: AxiosResponse<any>
  ): ResponseBagSttDetail {
    const {
      data: { data }
    } = result;
    return new ResponseBagSttDetail({
      ...convertSnakeToCamel(data),
      bagOrStt: data?.bag_or_stt
    });
  }

  public convertSearchCargoOptionsFromApi(
    result: AxiosResponse
  ): SearchCargoOptions {
    const { data } = result;
    const cargoOptions: SearchCargoOption[] = [];
    if (data.data !== null) {
      for (const cargoOption of data.data) {
        cargoOptions.push(
          new SearchCargoOption(
            cargoOption.transport_label,
            cargoOption.transport_type
          )
        );
      }
    }
    return new SearchCargoOptions(cargoOptions);
  }

  public convertAirportDataFromApi(
    result: AxiosResponse<any>
  ): AirportEntities {
    const { data } = result;

    if (data.data.length === 0) {
      return new AirportEntities(new Pagination(1, 10), []);
    } else {
      return new AirportEntities(
        new Pagination(data.meta.page, data.meta.limit),
        data.data.map(
          (item: any) =>
            new AirportData(
              item.airport_code,
              item.airport_name,
              item.city_code,
              item.city_name,
              item.office,
              item.participant_id
            )
        )
      );
    }
  }

  public convertAirportDetailDataFromApi(
    result: AxiosResponse<any>
  ): AirportDetail {
    const { data } = result;

    return new AirportDetail(data.data.airport_code, data.data.airport_name);
  }

  public convertAirportRouteTypeFromApi(
    result: AxiosResponse<any>
  ): AirportRouteTypeData {
    const { data } = result;
    const routeData = data.data;

    return new AirportRouteTypeData({
      routeType: routeData.route_type,
      maxGrossWeightKg: Number(routeData.max_gross_weight_kg) || 0,
      maxVolumeWeightKg: Number(routeData.max_volume_weight_kg) || 0,
      maxPieces: Number(routeData.max_pieces) || 0
    });
  }

  public convertCargoAddFromApi(result: AxiosResponse): CargoAddResponse {
    const {
      data: { data }
    } = result;
    return new CargoAddResponse(
      data.cargo_no,
      data.total_stt_success,
      data.total_stt_failed,
      data.list_stt_failed,
      data.is_cargo_using_awb,
      data.booking_request_id
    );
  }

  public convertEPLDownloadData(result: AxiosResponse): string {
    const { data } = result;
    return data;
  }

  public convertListLastReadCargoFromApi(
    res: AxiosResponse
  ): ListLastReadCargo[] {
    const { data } = res;
    const lastReadCargo: ListLastReadCargo[] = [];
    if (data.data === null) {
      return [];
    } else {
      if (data.data.cargo_success !== null) {
        data.data.cargo_success.map((item: any) => {
          lastReadCargo.push(
            new ListLastReadCargo({
              cargoNumber: item.cargo_number,
              awbNumber: item.awb_no,
              status: item.status,
              destination: item.destination,
              message: item.message
            })
          );
        });
      }
      if (data.data.cargo_failed !== null) {
        data.data.cargo_failed.map((item: any) => {
          lastReadCargo.push(
            new ListLastReadCargo({
              cargoNumber: item.cargo_number,
              awbNumber: item.awb_no,
              status: item.status,
              destination: item.destination,
              message: item.message
            })
          );
        });
      }
      return lastReadCargo;
    }
  }

  public convertPayloadData(result: AxiosResponse<any>): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      success: data.success,
      message: data.message
    });
  }

  public convertLastIdCargoAndRetryCargo(result: AxiosResponse): number {
    const {
      data: { data }
    } = result;
    return data.last_id;
  }

  public convertSearchFlightFromApi(
    result: AxiosResponse<any>
  ): SearchFlight[] {
    const { data } = result;
    return data.data.map((item: any) => {
      return new SearchFlight({
        orderId: item.order_id,
        departureDate: item.departure_date,
        arrivalDate: item.arrival_date,
        originAirportCode: item.origin_airport_code,
        destinationAirportCode: item.destination_airport_code,
        departureTime: item.departure_time,
        arrivalTime: item.arrival_time,
        transitNumber: item.transit_number,
        itineraries: item.itineraries ? item.itineraries.map((itineraries: any) => {
          return new SearchFlight({
            dailyFlightNo: itineraries.daily_flight_no,
            flightNo: itineraries.flight_no,
            departureDate: itineraries.departure_date,
            arrivalDate: itineraries.arrival_date,
            originAirportCode: itineraries.origin_airport_code,
            destinationAirportCode: itineraries.destination_airport_code,
            isNotSupportDg: itineraries.is_not_support_dg
          })
        }) : []
      })
    }); 
  }

  public convertCheckAvailableFromApi(
    result: AxiosResponse<any>
  ): FlightAvailable {
    const {
      data: { data }
    } = result;
    return new FlightAvailable({
      isAvailable: data.is_available
    });
  }

  public convertCargoAwbValidationFromApi(res: AxiosResponse): AwbDetailData {
    const { data } = res;

    if (typeof data !== "object" || !data) {
      return new AwbDetailData({ errorAwb: data });
    }

    return new AwbDetailData({
      errorAwb: "",
      awbDetails: new AwbDetail(convertSnakeToCamel(data.awb_details?.[0])),
      stockInformation: new StockInformation(
        convertSnakeToCamel(data.stock_information?.[0])
      ),
      awbTracking: Array.isArray(data.awb_tracking)
        ? data.awb_tracking.map(
            (t: any) => new AwbTracking(convertSnakeToCamel(t))
          )
        : []
    });
  }

  public convertCalculateVolumeFromApi(
    result: AxiosResponse<any>
  ): CalculateVolume {
    const {
      data: { data }
    } = result;
    return new CalculateVolume(convertSnakeToCamel(data));
  }

  public convertCargoMinimumWeightSummaryFromApi(res: AxiosResponse<any>): CargoMinimumWeightSummaryData {
    const {
      data: { data }
    } = res;

    return new CargoMinimumWeightSummaryData({
      totalData: data.minimum_volume_total,
      totalMinimumVolume: data.minimum_volume_count,
      totalPercentageMinimumVolume: data.minimum_volume_percentage,
      startDate: data.start_date,
      endDate: data.end_date,
    })
  }

  public convertCargoSummaryInProcess(res: AxiosResponse): CargoSummaryInProcessData {
    const {
      data: { data }
    } = res;

    return new CargoSummaryInProcessData({
      inProcessTotal: data.in_process_total
    });
  }

  public convertCargoFailedUnreadFromApi(res: AxiosResponse): CargoFailedUnread {
    const {
      data: { data }
    } = res;

    return new CargoFailedUnread({
      isShow: data.is_show,
      newRcId: data.new_rc_id
    });
  }

  public convertCheckEligibleReadyToCargo(res: AxiosResponse): CheckEligibleReadyToCargo {
    const {
      data: { data }
    } = res;

    return new CheckEligibleReadyToCargo({
      isEligible: data.is_eligible,
      bagOrStt: data.bag_or_stt?.map((item: any) => 
        new BagOrStt({
          sttNo: item.stt_no,
          bagNo: item.bag_no,
          reasonCode: item.reason_code,
          message: item.message,
          messageEn: item.message_en,
        })
      )
    });
  }
}
